
export default function Loading() {

    return (
        <p align="center">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
        </p>
    )

}